export default __webpack_public_path__ + "media/images/portfolio/gallery-02-390x230-dbf044f2c6b96ae6cd571227faa1ee2f.jpg";